<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'un Contact</span>
    </sticky>

    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <contact-form @submit="submit" :loading="loading" :sourceSeller="seller"></contact-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import ContactForm from '@/components/contact/ContactForm'

  export default {
    name: 'ContactCreate',
    components: {
      ContactForm
    },
    data () {
      return {
        geoAddress: {},
        loading: false,
        nextPage: null,
        contact: {},
        seller: null,
        address: {
          line1: null,
          city: null,
          zip_code: null,
          country: null
        },
        sellers: []
      }
    },
    computed: {
      ...mapState(['origins']),
      ...mapGetters(['isSeller', 'isAdmin', 'isManager', 'currentUserPk', 'isExternal', 'originGroups'])
    },
    methods: {
      submit (contact) {
        this.loading = true
        if (this.seller) {
          contact.seller = this.seller
        }
        this.$api.contactService.post(contact).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Contact enregistré.'
          })
          if (this.nextPage) {
            let nextPage = this.nextPage + '?addContact=' + res.data.pk
            this.$router.push(nextPage)
          } else {
            this.$router.goBack(this.$route)
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du contact.'
          })
        })
      }
    },
    created () {
      if ('next' in this.$route.query && this.$route.query.next.length > 0) {
        this.nextPage = this.$route.query.next
      }
      if ('seller' in this.$route.query) {
        this.seller = this.$route.query.seller
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/contact/ContactCreate.vue